let activeMagnifier = null;
let activeMagnifierImage = null;

function setMagnifierLoading(image, isLoading) {
  const loadingSpinner = image.parentElement?.parentElement?.querySelector('.loading__spinner');
  loadingSpinner?.classList.toggle('hidden', !isLoading);
}

function closeMagnifier({ restoreFocus = false } = {}) {
  if (!activeMagnifierImage) return;

  const image = activeMagnifierImage;
  activeMagnifier?.remove();
  setMagnifierLoading(image, false);
  image.style.opacity = '100%';
  image.setAttribute('aria-pressed', 'false');
  activeMagnifier = null;
  activeMagnifierImage = null;

  if (restoreFocus) image.focus({ preventScroll: true });
}

function prepareMagnifier(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.currentSrc || image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function moveMagnifier(image, container, event, zoomRatio) {
  const ratio = image.height / image.width;
  const bounds = container.getBoundingClientRect();
  const xPosition = event.clientX - bounds.left;
  const yPosition = event.clientY - bounds.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  container.style.backgroundPosition = `${xPercent} ${yPercent}`;
  container.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function openMagnifier(image, event, zoomRatio) {
  closeMagnifier();

  const magnifier = document.createElement('div');
  const preloadImage = new Image();
  prepareMagnifier(magnifier, image);
  activeMagnifier = magnifier;
  activeMagnifierImage = image;
  image.setAttribute('aria-pressed', 'true');
  image.style.opacity = '50%';
  setMagnifierLoading(image, true);

  preloadImage.onload = () => {
    if (activeMagnifier !== magnifier || activeMagnifierImage !== image) return;
    image.parentElement.insertBefore(magnifier, image);
    image.style.opacity = '100%';
    setMagnifierLoading(image, false);
    moveMagnifier(image, magnifier, event, zoomRatio);
  };
  preloadImage.onerror = () => closeMagnifier();
  preloadImage.src = image.currentSrc || image.src;

  magnifier.addEventListener('click', () => closeMagnifier({ restoreFocus: true }));
  magnifier.addEventListener('mousemove', (moveEvent) => moveMagnifier(image, magnifier, moveEvent, zoomRatio));
  magnifier.addEventListener('mouseleave', () => closeMagnifier());
}

function toggleMagnifier(image, event, zoomRatio) {
  if (activeMagnifierImage === image) {
    closeMagnifier({ restoreFocus: event.type === 'keydown' });
    return;
  }

  openMagnifier(image, event, zoomRatio);
}

function enableZoomOnHover(zoomRatio) {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  document.querySelectorAll('.image-magnify-hover').forEach((image) => {
    if (image.dataset.magnifierInitialized === 'true') return;
    image.dataset.magnifierInitialized = 'true';
    image.tabIndex = 0;
    image.setAttribute('role', 'button');
    image.setAttribute('aria-pressed', 'false');

    image.addEventListener('click', (event) => toggleMagnifier(image, event, zoomRatio));
    image.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();

      const bounds = image.getBoundingClientRect();
      toggleMagnifier(
        image,
        {
          type: 'keydown',
          clientX: bounds.left + bounds.width / 2,
          clientY: bounds.top + bounds.height / 2,
        },
        zoomRatio
      );
    });
  });
}

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && activeMagnifierImage) closeMagnifier({ restoreFocus: true });
});

enableZoomOnHover(2);
